module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "scrollArea",
    style: (_vm.inner)
  }, [_c('el-scrollbar', {
    ref: "elScrollbar",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "titles",
    staticStyle: {
      "text-align": "center",
      "height": "60px",
      "line-height": "60px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                人才培养方案\n            ")]), _vm._v(" "), _c('el-row', [_c('teaching-form', {
    ref: "teachingForm",
    attrs: {
      "isEdit": _vm.isEdit,
      "state": _vm.state
    },
    on: {
      "loadParams": _vm.loadParams
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('occupation-scope', {
    ref: "occupation",
    attrs: {
      "state": _vm.state
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('talent', {
    ref: "talent",
    attrs: {
      "state": _vm.state
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('teaching-weeks', {
    ref: "teachingWeeks",
    attrs: {
      "state": _vm.state
    },
    on: {
      "transweeks": _vm.transweeks,
      "changeArrange": _vm.changeArrange
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('CAP', {
    ref: "CAP",
    attrs: {
      "publicCourse": _vm.publicCourse,
      "majorCoreCourse": _vm.majorCoreCourse,
      "majorSkillCourse": _vm.majorSkillCourse,
      "electiveCourse": _vm.electiveCourse,
      "comprehensiveCourse": _vm.comprehensiveCourse,
      "other": _vm.other,
      "state": _vm.state
    },
    on: {
      "changeEditRow": _vm.changeEditRow,
      "openWindow": _vm.openWindow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('teaching-arrangement', {
    ref: "arrangement",
    attrs: {
      "state": _vm.state
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('comment', {
    ref: "comment",
    attrs: {
      "state": _vm.state,
      "filelist": _vm.filelist,
      "etype": _vm.etype
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p')]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p')]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "myfooter"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting,
      "disabled": _vm.state
    },
    on: {
      "click": function($event) {
        return _vm.saveScheme('save')
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting,
      "disabled": _vm.state
    },
    on: {
      "click": function($event) {
        return _vm.submitWapper()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "danger",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.saveScheme('audit')
      }
    }
  }, [_vm._v("审 核")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40410e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/schemeView.vue
// module id = 1816
// module chunks = 502